import Grid, { GridItem, GridItemStill, ObjectFit } from '../../generic/Grid';
import { Link, graphql } from 'gatsby';
import Section, { size } from '../../generic/Section';
import styles from './index.module.scss';

import GridItemHero from '../../generic/Grid/GridItemHero';
import React from 'react';
import { isBuildTargetWebex } from '../../../utils/getBuildTarget';

export default function WorkspaceHome({ heading, description, sections }) {
  return (
    <Section size={size.max} className={isBuildTargetWebex() ? styles.webex : undefined}>
      <Grid>
        <GridItemHero heading={heading} description={description} />
        {sections.map(category => {
          let target = '';
          if (category.workspaceSubCategories?.length === 1) {
            let subCategory = category.workspaceSubCategories[0];
            target = ['/workspaces', category.slug, subCategory.slug, subCategory.workspaces[0].slug].join('/');
          } else {
            target = ['/workspaces', category.slug].join('/');
          }

          let [gridImage] = category.images;
          let { x, y } = {
            x: !isNaN(gridImage?.focalPoint?.x) ? gridImage.focalPoint.x : 50,
            y: !isNaN(gridImage?.focalPoint?.y) ? gridImage?.focalPoint?.y : 50,
          };
          let imagePosition = `${x}% ${y}%`;

          return (
            <GridItem key={category.id} gridSize={category.gridSize}>
              <Link className={styles.link} to={target}>
                <GridItemStill
                  key={category.id}
                  objectFit={ObjectFit.cover}
                  objectPosition={imagePosition}
                  heading={category.heading}
                  description={category.description?.description}
                  backgroundColor={category.backgroundColor}
                  gridSize={category.gridSize}
                  image={gridImage.image}
                  numberOfSeats={category.numberOfSeats}
                  physicalSizeM2={category.physicalSizeM2}
                  gridLayout={category.layout}
                  gridImagePad
                />
              </Link>
            </GridItem>
          );
        })}
      </Grid>
    </Section>
  );
}

export const fragment = graphql`
  fragment WorkspaceHomeSection on ContentfulWorkspaceCategory {
    id
    heading
    slug
    numberOfSeats
    body {
      body
    }
    description {
      description
    }
    images {
      ...PwpImage
    }
    gridSize
    workspaceSubCategories {
      slug
      workspaces {
        slug
      }
    }
  }
`;
